import template from './futureFinancialGoals.html';
import controller from './futureFinancialGoalsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanApplicants: '<',
    loanAppFormWarning: '<',
    isLodged: '<',
    countValids: '&',
  },
};
